module.exports = __webpack_public_path__ + "static/img/20210113165825.6ce97bb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/20210113165825.jpg
// module id = foVw
// module chunks = 2